var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expert_team_video container"},[_c('div',{staticClass:"expert_team_video_main"},[_c('video',{staticClass:"video__inner",attrs:{"src":_vm.detail.videoUrl,"controls":""}})]),_c('div',{staticClass:"expert_team_poster"},[_c('img',{staticClass:"image__inner",attrs:{"src":_vm.detail.poster + '?imageMogr2/format/webp'}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }